import PatientService from './PatientService';

export default PatientService;
